'use strict';
angular.module('plancenterInfoModule', [])
    .controller('infoDetailsCtrl', function($scope, commandService, leftService) {
        var msgId = leftService.getParamValue('msgId');
        commandService.infoinvoke('getPlanInformation', { InformationId: msgId }).then(
            function(data) {
                if (angular.isObject(data.USERNAME)) {
                    var arr = [];
                    angular.forEach(data.USERNAME, function(user, idx) {
                        arr.push(user.NAME);
                    });
                    data.allname = arr.join(',');
                } else {
                    data.allname = data.USERNAME;
                }
                $scope.info = data;
            });
        $scope.close = function() {
            $modalInstance.dismiss();
        };
    })
